import { isGuest } from "@utils/permissions";
import { ControlPoint, File, Project, ProjectDocument, User } from "types";

export const getDocumentsFromProject = (project?: Project) => {
  if (!project) return [];
  const documents: ProjectDocument[] = [];
  project.folders.forEach((folder) => {
    folder.documents?.forEach((doc) => {
      documents.push(doc);
    });
    folder.sub_folders?.forEach((subFolder) => {
      subFolder.documents?.forEach((doc) => {
        documents.push(doc);
      });
    });
  });
  return documents;
};

export const getDocumentByIdFromProject = (
  project?: Project,
  documentId?: string,
) => {
  if (!project || !documentId) return undefined;
  for (const folder of project.folders) {
    const doc = folder.documents?.find((d) => d.id === documentId);
    if (doc) return doc;
    for (const subFolder of folder.sub_folders || []) {
      const subDoc = subFolder.documents?.find((d) => d.id === documentId);
      if (subDoc) return subDoc;
    }
  }

  return undefined;
};

export const updateDocumentInProject = (
  project: Project,
  updatedDocument: ProjectDocument,
): Project => {
  const updatedFolders = project.folders.map((folder) => {
    const updatedDocuments = folder.documents?.map((doc) => {
      if (doc.id === updatedDocument.id) {
        return updatedDocument;
      }
      return doc;
    });
    const updatedSubFolders = folder.sub_folders?.map((subFolder) => {
      const updatedSubDocuments = subFolder.documents?.map((doc) => {
        if (doc.id === updatedDocument.id) {
          return updatedDocument;
        }
        return doc;
      });
      return { ...subFolder, documents: updatedSubDocuments };
    });
    return {
      ...folder,
      documents: updatedDocuments,
      sub_folders: updatedSubFolders,
    };
  });
  return { ...project, folders: updatedFolders };
};

export const getFilesFromProject = (project?: Project) => {
  if (!project) return [];
  const files: File[] = [];
  project.folders.forEach((folder) => {
    folder.documents?.forEach((doc) => {
      files.push(doc.file);
    });
  });
  return files;
};

export const getPhotosByIdsFromProject = (
  project?: Project,
  photoIds?: string[],
  userData?: User,
) => {
  if (!project || !photoIds) return [];
  const photos = project.photos
    .filter((photo) => photoIds.includes(photo.id))
    .filter((photo) => (isGuest(userData) && photo.hidden ? false : true)); // if user is guest, filter out hidden photos
  return photos;
};

export const getVisiblePhotosFromProject = (
  project?: Project,
  userData?: User | null,
) => {
  if (!project) return [];
  const photos = project.photos.filter((photo) =>
    isGuest(userData) ? !photo.hidden : true,
  );
  return photos;
};

export const getControlPointsFromProject = (project?: Project) => {
  if (!project) return [];
  const controlPoints: ControlPoint[] = [];
  project.themes.forEach((theme) => {
    theme.steps.forEach((step) => {
      step.controlpoints.forEach((cp) => {
        controlPoints.push(cp);
      });
    });
  });
  return controlPoints;
};

export const getProjectWithUpdatedControlPoint = (
  project: Project,
  updatedControlPoint: ControlPoint,
): Project => {
  const updatedThemes = project.themes.map((theme) => {
    const updatedSteps = theme.steps.map((step) => {
      const updatedControlPoints = step.controlpoints.map((cp) => {
        if (cp.id === updatedControlPoint.id) {
          return updatedControlPoint;
        }
        return cp;
      });
      return { ...step, controlpoints: updatedControlPoints };
    });
    return { ...theme, steps: updatedSteps };
  });
  return { ...project, themes: updatedThemes };
};
